import { ClientPropertiesType } from '../../../Types/ClientModelTypes';

/**
 * Makes a shallow clone of a map, setting or overriding the specified property with the given value
 * @param name The property name to set
 * @param value The new value
 * @param properties The map to clone
 */
export const setProperty = (
  name: string,
  value: string,
  properties: ClientPropertiesType | undefined
) => {
  const clonedProperties = new Map(properties || []);

  clonedProperties.set(name, value);

  return clonedProperties;
};
